import { gql } from '@apollo/client';

export const getStates = gql`
  query getStates {
    getStates
  }
`;
